import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import {
  Form,
  Card,
  Col,
  InputGroup,
  Button,
  Row,
  Spinner,
} from "@themesberg/react-bootstrap";
import CustomDashboardLoader from "../../components/CustomDashboardLoader";
import {
  addSahakariCustomerByCsv,
  clearSahakari,
  getSahakari,
} from "../../redux/actions/sahakari";
import { useSelector, useDispatch } from "react-redux";

const AddSahakariCustomers = () => {
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedSahakari, setSelectedSahakari] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState("");

  const sahakariData = useSelector((state) => state.sahakari.sahakariData);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getSahakari()).then(() => setIsLoading(false));
    return () => {
      dispatch(clearSahakari());
    };
  }, []);

  const onFileChange = (e) => {
    // const CSV_REGEX = new RegExp("(.*?).(csv)$");
    const csvHelperArray = [
      "csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ".csv",
    ];
    if (csvHelperArray.includes(e.target.files[0].type)) {
      setSelectedFile(e.target.files[0]);
    } else {
      toast.error("Only CSV files are allowed");
      setSelectedFile(null);
    }
  };

  const handleSuccess = () => {
    setIsSubmitting(false);
  };
  const handleFailure = () => {
    setIsSubmitting(false);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    let hasErrors = false;

    if (selectedFile === null) {
      toast.error("Please select a CSV file");
      hasErrors = true;
      return;
    }
    if (!/\S/.test(selectedSahakari)) {
      setErrors("Please select a sahakari branch");
      hasErrors = true;
    } else {
      setErrors("");
    }

    if (hasErrors) {
      toast.error("Please check all the form fields");
    } else {
      const submitData = new FormData();
      submitData.append("csvfile", selectedFile);
      setIsSubmitting(true);
      dispatch(
        addSahakariCustomerByCsv(
          selectedSahakari,
          submitData,
          handleSuccess,
          handleFailure
        )
      );
    }
  };

  return (
    <>
      {isLoading ? (
        <CustomDashboardLoader />
      ) : (
        <Card border="light" className="bg-white shadow-sm mb-4 p-0">
          <Card.Body>
            <h5 className="mb-4">Bulk upload Customers</h5>
            <Form noValidate onSubmit={submitHandler}>
              <Row>
                <Col md={12} className="mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Select Sahakari</Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      value={selectedSahakari}
                      onChange={(e) => setSelectedSahakari(e.target.value)}
                    >
                      <option value={null}>{null}</option>
                      {sahakariData.map((item) => (
                        <option value={item[0]} key={item[0]}>
                          {item[2]} - ({item[4]})
                        </option>
                      ))}
                    </Form.Select>
                    {errors !== "" && (
                      <Form.Text className="text-danger">{errors}</Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Label>Select Csv file</Form.Label>
                  <br />
                  <input
                    type="file"
                    onChange={onFileChange}
                    accept=".csv, application/vnd.ms-excel"
                  />
                </Col>
                <div className="d-flex justify-content-end">
                  <Button
                    type="submit"
                    variant="primary"
                    className="m-1"
                    onClick={submitHandler}
                    disabled={isSubmitting}
                  >
                    {isSubmitting === true ? (
                      <Spinner animation="border" />
                    ) : (
                      "Add Customers"
                    )}
                  </Button>
                </div>
              </Row>
            </Form>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default AddSahakariCustomers;
